import PropTypes from "prop-types";

const IconBack = ({ size = 16, fill = "black", ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 16 16"
		fill="none"
		{...props}
	>
		<path
			d="M11.8901 2.57999L10.7034 1.39999L4.11011 7.99999L10.7101 14.6L11.8901 13.42L6.47011 7.99999L11.8901 2.57999Z"
			fill={fill}
		/>
	</svg>
);

IconBack.propTypes = {
	size: PropTypes.number,
	fill: PropTypes.string,
};

export default IconBack;
